import { CustomResponse } from '@/models/custom-response.model';
import CustomNavbar from '@/components/shared/custom-navbar/custom-navbar.component';
import CustomSidebar from '@/components/shared/custom-sidebar/custom-sidebar.component';
import { CustomNotification } from '@/models/custom-notification.model';
import { CustomUser } from '@/models/custom-user.model';
import router from '@/router';
import axios from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Authentication = namespace('authentication');
const Notification = namespace('notification');

@Component({
    components: {
        CustomNavbar,
        CustomSidebar,
    },
})
export default class App extends Vue {

    @Authentication.Getter('isAuthenticated') private isAuthenticated: boolean;
    @Authentication.State('user') private user: CustomUser;
    @Notification.State('notifications') public notifications: CustomNotification[];
    @Notification.Action('addError') private addError: any;
    @Notification.Action('removeNotification') private removeNotification: any;

    private markedForRemoval: string[] = [];

    public created() {

        if (this.user && this.user.token) {
            axios.defaults.headers.common.Authorization = this.user.token;
        }

        axios.interceptors.response.use(undefined, (error) => {
            return new Promise((resolve, reject) => {
                if (error.response.status === 401) {
                    console.log('error', error.response);
                    const handledResponse: CustomResponse<any> = error.response.data;

                    this.addError(handledResponse.localized);
                    this.$store.dispatch('authentication/logout', { root: true });
                    router.push('/login');
                }
                throw error;
            });
        });

    }

    public updated() {
        this.notifications.forEach((notification) => {
            if (!this.markedForRemoval.includes(notification.uuid)) {
                this.markedForRemoval.push(notification.uuid);
                setTimeout(() => {
                    this.removeNotification(notification.uuid);
                }, 5000);
            }
        });
    }

    @Watch('$route', { immediate: true, deep: true }) private onRouteChange(to, from) {
        // this.clearNotifications();
    }

    public getCssClasses(notification: CustomNotification): string[] {
        const cssClasses = ['alert', 'mb-2', 'mt-0', 'mr-2'];

        switch (notification.type) {
            case('ERROR'):
                cssClasses.push('alert-danger');
                break;
            case('WARNING'):
                cssClasses.push('alert-warning');
                break;
            default:
                cssClasses.push('alert-success');
        }

        return cssClasses;
    }

}
